// The server derives `mode` (docs/Authentication.md): 'disabled' without the
// tenant settings, 'pilot' before the cutoff, 'public' from it
// (ENTRA_MIGRATION=cutoff or closed).

// Microsoft sign-in (/signin) is available whenever the server enables it.
export const isEntraSigninAvailable = (capabilities) => Boolean(capabilities?.enabled);

// From the cutoff new users register with Microsoft only.
export const requiresEntraForNewUsers = (capabilities) => capabilities?.mode === 'public';

// From the cutoff (ENTRA_MIGRATION=cutoff or closed) the legacy login is closed:
// /login is the new page and the legacy-only pages lead there.
export const isLegacyLoginClosed = (capabilities) => (
  capabilities?.migration === 'cutoff' || capabilities?.migration === 'closed'
);

export const canCompleteEntraInvitation = (capabilities) => (
  capabilities?.mode === 'public' || capabilities?.mode === 'pilot'
);
